const store = new Vuex.Store({
    state: {
        width: 0,
        height: 0,
    },
    getters: {
        width: state => state.width,
        height: state => state.height,
    },
    mutations: {
        SETUP(state, app) {
            state.width = app.width
            state.height = app.height
        },
    },
    actions: {
        appSetup({ commit }, payload) {
            commit("SETUP", {
                width: window.innerWidth,
                height: window.innerHeight
            })
        },
        // fetchPrestas({ commit }, payload ) {
        //   return new Promise((resolve, reject) => {
        //       fetch(payload.url)
        //       .then(stream => stream.json())
        //       .then(data => {
        //           commit("FETCH_NBPRESTAS", data.items.length);
        //           commit("FETCH_TITLE", data.title);
        //           commit("FETCH_LAYOUT", data.layout);
        //           commit("FETCH_GROUPESFILTRES", data.filtres);
        //           commit("FETCH_PRESTASITEMS", data.items);
        //           // history.pushState(null, null, );
        //           resolve();
        //       })
        //       .catch((error) => {
        //           console.log(error.statusText);
        //       });
        //   });
        // }
    }
})